class LoadMore extends HTMLElement { 
  constructor(){
    super();
    this.addEventListener("click", this.loadMoreResults);
    this.loadMoreBtn = document.querySelector('[data-load-more]');
    this.resourceGridNode = document.querySelector('[data-resource-grid]');
  }

  removePhcursorFromUrl(urlString) {
    const url = new URL(urlString, window.location.origin);
    url.searchParams.delete('phcursor');
    return url.pathname + (url.search ? '?' + url.searchParams.toString() : '');
  }

  loadMoreResults() { 
    const { currentPage, pageSize, nextUrl, totalItems } = this.dataset
    const nextPage = parseInt(currentPage) + 1
    
    /** Disable btn and activate spinner when fetching data */
    this.loadMoreBtn.setAttribute("disabled", true);
    this.loadMoreBtn.classList.add('button__loading')

    let doc;
    const cleanUrl = this.removePhcursorFromUrl(nextUrl);
    fetch(cleanUrl.replace(/page=[0-9]+/,'page='+ nextPage))
      .then((response) => response.text())
      .then((responseHTML) => {
        /** Render next page products */
        doc = new DOMParser().parseFromString(responseHTML, 'text/html');
        const nextPageResults = doc.querySelectorAll('[data-resource]');
        nextPageResults.forEach((node) => this.resourceGridNode.append(node));
      }).catch((error) => {
        /** Render next page products */
        console.error('Failed to fetch next page resources - ', error)
      })
      .finally(() => {
        this.remainingCountNode = this.querySelector('[data-remaining-count]')
        this.dataset.currentPage = parseInt(currentPage) + 1;

        /** Deactivate spinner after fetching data */
        this.loadMoreBtn.classList.remove('button__loading');

        const isLastPage = parseInt(totalItems) - (nextPage * parseInt(pageSize) ) < 0

        if (isLastPage) {
          this.remainingCountNode.innerHTML = 0;
        } else {
          /** Enable btn and set remmaining product count if there are more products */
          this.loadMoreBtn.removeAttribute("disabled");
          this.remainingCountNode.innerHTML = parseInt(totalItems) - (nextPage * parseInt(pageSize));
        }

        const pagination = doc.getElementById('ProductGridContainer').querySelector('load-more');
        if (!pagination) {
          this.remove();
        }
      });
  }
}

customElements.define('load-more', LoadMore);
